import React from "react";
import { Plus } from "../assets/svg/AllSvg";
import { Logo } from "../assets";
import ShareholderCard from "./ShareholderCard";

const ShareholderList = ({
  shareholders = [],
  onAddShareholder,
  onEditShareholder,
  onDeleteShareholder,
  showAddButton = true,
  showNomineeCard = false,
  nomineeTitle = "SGCorpHub Nominee Shareholder",
  addButtonText = "Add shareholder",
  className = "",
  maxHeight = "max-h-80",
}) => {
  return (
    <div className={`space-y-4 ${className}`}>
      {/* Shareholders List */}
      <div
        className={`space-y-4 overflow-y-auto mb-4 ${
          shareholders?.length && "p-3"
        } ${maxHeight}`}
      >
        {shareholders?.map((shareholder, index) => (
          <ShareholderCard
            key={shareholder?.id || index}
            shareholder={shareholder}
            onEdit={onEditShareholder}
            onDelete={onDeleteShareholder}
          />
        ))}
      </div>

      {/* Nominee Shareholder Card */}
      {showNomineeCard && (
        <div className="p-3 pt-0">
          <div className="card bg-white border flex space-x-3 items-center">
            <img src={Logo} alt="logo" className="sm:w-10 sm:h-10 w-6 h-6" />
            <p className="lg:text-xl sm:text-base text-sm font-medium">
              {nomineeTitle}
            </p>
          </div>
        </div>
      )}

      {/* Add Shareholder Button */}
      {showAddButton && (
        <button
          type="button"
          className="btn-outline uppercase flex items-center ml-3"
          onClick={onAddShareholder}
        >
          <Plus className="fill-theme mr-2" />
          {addButtonText}
        </button>
      )}
    </div>
  );
};

export default ShareholderList;
